/**
 * Copyright Open Logistics Foundation
 *
 * Licensed under the Open Logistics Foundation License 1.3.
 * For details on the licensing terms, see the LICENSE file.
 * SPDX-License-Identifier: OLFL-1.3
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TemplateUser } from '@app/shared/models/ecmr/TemplateUser';
import { EcmrUrlResolverService } from './ecmr-url-resolver.service';

@Injectable({
    providedIn: 'root',
})
export class TemplateOverviewService {
    constructor(
        private http: HttpClient,
        private ecmrUrlResolver: EcmrUrlResolverService
    ) {}

    getAllTemplates(organizationSite: string) {
        return this.http.get<TemplateUser[]>(
            `${this.ecmrUrlResolver.getEcmrUrl()}/${organizationSite}/template`
        );
    }

    deleteTemplate(organizationSite: string, id: number) {
        return this.http.delete(
            `${this.ecmrUrlResolver.getEcmrUrl()}/${organizationSite}/template/${id}`
        );
    }

    shareTemplate(id: number, userIds: number[]) {
        return this.http.post<TemplateUser>(
            `${this.ecmrUrlResolver.getEcmrUrl()}/template/share/${id}`,
            userIds
        );
    }

    saveDisplayedColumns(columns: string[]) {
        const columnString: string = JSON.stringify(columns);
        localStorage.setItem('templateColumns', columnString);
    }

    getDisplayedColumns(): string[] | null {
        const columnString: string | null =
            localStorage.getItem('templateColumns');
        if (columnString) {
            return JSON.parse(columnString);
        } else {
            return null;
        }
    }
}
